import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

// ..
AOS.init();
// ..

// Path: ATMOS-react/src/pages/HomePage/assets/js/main.js